'use strict';

var React = require('react');

var SvgCreditCardPercentMajor = function SvgCreditCardPercentMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1a1.5 1.5 0 0 0-1.5 1.5v1.5h20v-1.5a1.5 1.5 0 0 0-1.5-1.5h-17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.5v-7.5h20v3h-6c-2.757 0-5 2.236-5 4.987v1.013h-7.5a1.5 1.5 0 0 1-1.5-1.5zm2-3.5h5v-2h-5v2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 17.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.707 11.293a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0z"
  }));
};

exports.SvgCreditCardPercentMajor = SvgCreditCardPercentMajor;
